import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function TagsFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/tags/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      label={t("Tags")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.tag_id?.split(",") || []}
      onSelectionChange={(keys) => setParam("tag_id", Array.from(keys))}
      items={data}
      testID="tags-filter-picker"
    />
  );
}
